import { createStore } from 'redux'

// Mirrors CoreUI's $mobile-breakpoint: md — the same query that declares
// --cui-is-mobile in @coreui/coreui-pro. Keep the two in sync.
// Seeding sidebarShow from the viewport avoids a first-paint flash on phones:
// CSidebar detects "mobile" only after mount, so an initial `true` makes it
// slide open and straight back out with a backdrop.
const isMobileViewport = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(max-width: 767.98px)').matches

const initialState = {
  sidebarShow: !isMobileViewport(),
  sidebarUnfoldable: false,
  asideShow: false,
  theme: 'default',
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
